import { AxiosError } from "axios";
import { getApi } from "../CreateApi";
import { ResponseGetSearchUser } from "./interfaceSearchUsers";

export const getSearchAdvanced = async (params?: any): Promise<any> => {
    try {
        const data = await getApi(`/person/advanced-search`, params);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as AxiosError;
    }
}